<template>
    <div class="loader">
        <loader :width="60" :height="60"/>
    </div>
</template>
<script>
/**
 * The user will be sent here from the link in the verify account e-mail address.
 * This will simply make an ajax call to verify and then redirect the user to step 1
 * of the amrketing journey.
 */
import { mapActions } from 'vuex';

export default {
    name: 'MarketingVerify',
    mounted() {
        this.verify();
    },
    methods: {
        ...mapActions({
            verify: 'Marketing/emailVerify'
        })
    }
};
</script>

<style lang="scss" scoped>
.loader {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Marketing/Verify.vue